import React from 'react'
import { PaymentRequestButtonElement } from '@stripe/react-stripe-js'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faBank, faCircleNotch } from '@fortawesome/free-solid-svg-icons'

import BankList from './BankList'

const CommonButton = ({ i18n, donation, record, disabled }) =>
  <div className="d-grid">
    <button
      className="btn btn-lg btn-primary"
      disabled={record.processing || disabled}
    >
      {i18n.t('donate_total_recurrence', {
        total: i18n.formatCurrency(donation.total, donation.currency),
        recurrence: i18n.t(`subscription_labels.${donation.state.subscription}.submit`),
      })}
    </button>
  </div>

const SubmitButton = ({
  i18n, donation, record, creditCard, bank, paypal, foundation, paymentOption
}) => {
  switch (paymentOption) {
    case 'paymentRequest': return (
      <div>
        <PaymentRequestButtonElement options={{
          paymentRequest: creditCard.paymentRequest,
          style: {
            paymentRequestButton: {
              type: foundation ? 'donate' : 'default',
              height: '48px',
            },
          }
        }} onClick={creditCard.openPaymentSheet} />
        <button
          className="visually-hidden"
          disabled={record.processing}
          tabIndex="-1"
        />
      </div>
    )
    case 'credit_card':
      return <CommonButton i18n={i18n} donation={donation} record={record} />
    // Continue saves the draft (and, for a recurring gift, the PayPal plan)
    // before the summary comes up, which takes a moment.
    case 'paypal':
    case 'venmo': return (
      <div className="d-grid">
        <button className="btn btn-primary" disabled={record.processing || paypal.loading}>
          {paypal.loading && <FontAwesomeIcon icon={faCircleNotch} spin className="me-2" />}
          {paypal.loading ? i18n.t('loading') : i18n.t('continue')}
        </button>
      </div>
    )
    case 'bank':
      if (bank.error) return (
        <div className="alert alert-danger mb-0">{bank.error}</div>
      )
      else if (bank.accounts.length) return (
        <div>
          <BankList i18n={i18n} bank={bank} />
          <CommonButton
            i18n={i18n}
            donation={donation}
            record={record}
            disabled={bank.loading || !bank.accountId}
          />
        </div>
      )
      else return (
        <div className="d-grid">
          <button
            className="btn btn-primary"
            disabled={record.processing || bank.loading}
          >
            {
              bank.loading
              ? <FontAwesomeIcon icon={faCircleNotch} spin className="me-2" />
              : <FontAwesomeIcon icon={faBank} className="me-2" />
            }
            Connect bank account
          </button>
        </div>
      )
  }
}

export default SubmitButton
